import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import IssueRequest from "../../magData/Flight/IssueRequest";
import ReserveResponse from "../../magData/Flight/ReserveResponse";

function FlightIssuePage() {

    return (
        <>

            <Container fluid >
                <Row>
                    <Col sm={12} >
                        <p className="page-title">Flight Issue Method</p>
                    </Col>
                    <Col sm={12} >
                        <p>EndPoint : https://gdscpapi.parsgds.com/gateway/flight/issue</p>
                    </Col>
                    <Col sm={12} >
                        <p> type : json (default)</p>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} >
                        <p>Body Parameters</p>
                    </Col>
                    <Col sm={12} >

                        <Table striped bordered>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Type</th>
                                    <th>Additional information</th>
                                </tr>
                            </thead>
                            <tbody>
                                   <tr>
                                    <td>gdsRefrenceID</td>
                                    <td>Refrence ID</td>
                                    <td>Guid </td>
                                    <td><Badge bg="warning" text="dark">
                                        Required
                                    </Badge></td>
                                </tr>
                               
                            </tbody>
                        </Table>
                    </Col>

                </Row>
                <Row>
                    <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
                    <Col sm={12}>

                        <pre className="code-section">
                            {JSON.stringify(IssueRequest, null, 2)}
                        </pre>


                    </Col>
                </Row>

                {/* Response  */}
                <Row>
                    <Col sm={12} >
                        <p>Response Information</p>
                    </Col>
                    <Col sm={12} >

                    <Table striped bordered>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Type</th>
                                    <th>Additional information</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>gdsRefrenceID</td>
                                    <td>Refrence ID</td>
                                    <td>Guid </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>tktTimeLimit</td>
                                    <td>Ticket Time Limit</td>
                                    <td>date </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>priceChange</td>
                                    <td> Respond Status</td>
                                    <td>boolean </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>reserveCode</td>
                                    <td>Booking identifier Code</td>
                                    <td>string </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>adultCount</td>
                                    <td>Adult Count</td>
                                    <td>integer </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>childCount</td>
                                    <td>Child Count</td>
                                    <td>integer </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>infantCount</td>
                                    <td>Infant Count</td>
                                    <td>integer </td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>

                </Row>
                <Row>
                    <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
                    <Col sm={12}>

                        <pre className="code-section">
                            {JSON.stringify(ReserveResponse, null, 2)}
                        </pre>


                    </Col>
                </Row>
            </Container>

        </>
    );
}

export default FlightIssuePage;